// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchable-input-dropdown-wrapper {
  width: 100%;
  max-width: 48px;
  display: flex;
  flex-direction: column;
  position: relative;
  border-bottom: 1px solid #d0566e;
}
.searchable-input-dropdown-wrapper input {
  width: 100%;
  border: none;
  font-size: 16px;
  border-radius: 8px;
  caret-color: #707070;
}
.searchable-input-dropdown-wrapper input:focus {
  outline: none;
}
.searchable-input-dropdown-wrapper input::placeholder {
  color: #707070;
}
.searchable-input-dropdown-wrapper input.disabled-styling {
  cursor: not-allowed;
}
.searchable-input-dropdown-wrapper .options-container {
  border-radius: 5px;
  padding: 4px 0px;
  scroll-snap-type: y mandatory;
  scroll-padding-top: 4px;
  background: #fff;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.11);
  position: absolute;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  margin-top: 5px;
  min-width: 100%;
  width: fit-content;
  max-height: 128px;
  overflow: auto;
  z-index: 1;
}
.searchable-input-dropdown-wrapper .options-container .country-code-options-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.searchable-input-dropdown-wrapper .options-container .country-code-options-list li {
  line-height: 32px;
  color: #3a3a3a;
  font-size: clamp(0.75rem, 0.7143rem + 0.1786vw, 0.875rem);
  font-weight: 400;
  padding: 4px 8px;
  margin: 0 4px;
  scroll-snap-align: start;
  white-space: nowrap;
}
.searchable-input-dropdown-wrapper .options-container .country-code-options-list li:hover {
  background: #f3f3f3;
  border-radius: 4px;
  cursor: pointer;
}
.searchable-input-dropdown-wrapper .options-container .country-code-options-list li.focused {
  background: #f3f3f3;
  border-radius: 4px;
}
.searchable-input-dropdown-wrapper .options-container .loading {
  line-height: 32px;
  color: #3a3a3a;
  font-size: clamp(0.75rem, 0.7143rem + 0.1786vw, 0.875rem);
  font-weight: 600;
  text-align: center;
  padding: 4px 8px;
  margin: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/SearchableCountryCodeDropdown/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gCAAA;AACF;AAEE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAGI;EACE,cAAA;AADN;AAII;EACE,mBAAA;AAFN;AAME;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,uBAAA;EACA,gBAAA;EACA,gDAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAJJ;AAMI;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AAJN;AAMM;EACE,iBAAA;EACA,cAAA;EACA,yDAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;EACA,mBAAA;AAJR;AAMQ;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;AAJV;AAOQ;EACE,mBAAA;EACA,kBAAA;AALV;AAUI;EACE,iBAAA;EACA,cAAA;EACA,yDAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AARN","sourcesContent":[".searchable-input-dropdown-wrapper {\n  width: 100%;\n  max-width: 48px;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  border-bottom: 1px solid #d0566e;\n\n  \n  input {\n    width: 100%;\n    border: none;\n    font-size: 16px;\n    border-radius: 8px;\n    caret-color: #707070;\n    \n    &:focus {\n      outline: none;\n    }\n    \n    &::placeholder {\n      color: #707070;\n    }\n    \n    &.disabled-styling{\n      cursor: not-allowed;\n    }\n  }\n\n  .options-container {\n    border-radius: 5px;\n    padding: 4px 0px;\n    scroll-snap-type: y mandatory;\n    scroll-padding-top: 4px;\n    background: #fff;\n    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.11);\n    position: absolute;\n    top: 100%;\n    right: 50%;\n    transform: translateX(50%);\n    margin-top: 5px;\n    min-width: 100%;\n    width: fit-content;\n    max-height: 128px;\n    overflow: auto;\n    z-index: 1;\n\n    .country-code-options-list {\n      list-style-type: none;\n      margin: 0;\n      padding: 0;\n\n      & li {\n        line-height: 32px;\n        color: #3a3a3a;\n        font-size: clamp(0.75rem, 0.7143rem + 0.1786vw, 0.875rem);\n        font-weight: 400;\n        padding: 4px 8px;\n        margin: 0 4px;\n        scroll-snap-align: start;\n        white-space: nowrap;\n\n        &:hover {\n          background: #f3f3f3;\n          border-radius: 4px;\n          cursor: pointer;\n        }\n\n        &.focused{\n          background: #f3f3f3;\n          border-radius: 4px;\n        }\n      }\n    }\n\n    .loading{\n      line-height: 32px;\n      color: #3a3a3a;\n      font-size: clamp(0.75rem, 0.7143rem + 0.1786vw, 0.875rem);\n      font-weight: 600;\n      text-align: center;\n      padding: 4px 8px;\n      margin: 0 4px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
